import IconChevronDown from "@shared/components/icons/ChevronDown"
import { cx } from "@shared/components/untitledui/util/cx"

/**
 * The chevron on a row that expands a section in place: down when the section is open, turned a
 * quarter to the left when it is closed. Shared so the Add menu's File row and the lesson menu's
 * section pills point the same way through the same turn — they cannot share the disclosure
 * itself, since one lives in a React Aria Menu collection and the other in a Dialog.
 */
export function ExpandChevron({
  isExpanded,
  className,
}: {
  isExpanded: boolean
  className?: string
}) {
  return (
    <span
      aria-hidden
      className={cx(
        "flex size-4 shrink-0 text-gray-400 transition-transform duration-200",
        isExpanded ? "rotate-0" : "-rotate-90",
        className,
      )}
    >
      <IconChevronDown className="size-full" />
    </span>
  )
}
